import { Banner } from "@freightsimple/ui-core/Display/Banner";
import { T } from "@freightsimple/ui-core/Typography/T";
import { ShipmentFlagType } from "@freightsimple/generated-carriers-openapi-client/models/ShipmentFlagType";
import { type ShipmentFlag } from "@freightsimple/generated-carriers-openapi-client/models/ShipmentFlag";

// What each flag means, said plainly. These are conditions we've recorded against
// the freight — the carrier is being told what we know, not asked a question, so
// there's no action on the banner.
const FLAG_TITLES: Record<ShipmentFlagType, string> = {
  [ShipmentFlagType.Missing]: "Freight Missing",
  [ShipmentFlagType.Damaged]: "Freight Damaged",
  [ShipmentFlagType.Shortage]: "Freight Short",
};

const FLAG_DESCRIPTIONS: Record<ShipmentFlagType, string> = {
  [ShipmentFlagType.Missing]:
    "We can't account for this freight. If it turns up at a terminal, tell us as soon as you know.",
  [ShipmentFlagType.Damaged]:
    "This freight was recorded as damaged. Photos and your inspection notes help us settle it.",
  [ShipmentFlagType.Shortage]:
    "Fewer handling units arrived than were shipped. The missing pieces may still be at a terminal.",
};

/**
 * A condition recorded against the freight itself — missing, damaged, or short.
 *
 * Always the loudest thing on the page: freight that is lost or broken outranks
 * any task, because it is the outcome those tasks exist to prevent.
 */
export function FlagBanner({ flag }: { flag: ShipmentFlag }) {
  return (
    <Banner variant="danger" title={FLAG_TITLES[flag.flagType]}>
      <T size="sm">
        {FLAG_DESCRIPTIONS[flag.flagType]}
        {flag.since ? ` Recorded ${flag.since}.` : ""}
      </T>
    </Banner>
  );
}
